import { defineStore } from 'pinia'
import { ref} from "vue";
import type { Entidade } from '@/entities/Entidade'


export const useEntidadeStore = defineStore(
    'entidade-folha-24', () => {
        const entidadeSelecionada = ref<Entidade>();

        function getEntidadeSelecionada() {
            return entidadeSelecionada.value;
        }

        function setEntidadeSelecionada(entidade: Entidade) {
            entidadeSelecionada.value = entidade;
        }

        function deleteEntidadeSelecionada() {
            entidadeSelecionada.value = undefined;
        }

        return { entidadeSelecionada, getEntidadeSelecionada, setEntidadeSelecionada, deleteEntidadeSelecionada: deleteEntidadeSelecionada }
    },
)
